/**
 * The Aldemis Foundry logo, inline so the wordmark's text renders in the loaded
 * Quattrocento / Oswald web fonts (an SVG in an <img> would not see them).
 */

const marks = (
  <g transform="translate(100,58) scale(0.98)" fill="#241C2B">
    <path d="M-23,0 L23,0 L29,24 L-29,24 Z" fill="#4A8A78" />
    <path d="M-55.5,31 L-9.5,31 L-3.5,55 L-61.5,55 Z" />
    <path d="M9.5,31 L55.5,31 L61.5,55 L3.5,55 Z" />
    <path d="M-88,62 L-42,62 L-36,86 L-94,86 Z" />
    <path d="M-23,62 L23,62 L29,86 L-29,86 Z" />
    <path d="M42,62 L88,62 L94,86 L36,86 Z" />
  </g>
);

/** Icon only. */
export function Mark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 200 200" className={className} role="img" aria-label="Aldemis Foundry">
      {marks}
    </svg>
  );
}

/** Icon + wordmark, for headers and the auth screen. */
export function Wordmark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 544 196" className={className} role="img" aria-label="Aldemis Foundry">
      <g transform="translate(104.8,62) scale(0.86)" fill="#241C2B">
        <path d="M-23,0 L23,0 L29,24 L-29,24 Z" fill="#4A8A78" />
        <path d="M-55.5,31 L-9.5,31 L-3.5,55 L-61.5,55 Z" />
        <path d="M9.5,31 L55.5,31 L61.5,55 L3.5,55 Z" />
        <path d="M-88,62 L-42,62 L-36,86 L-94,86 Z" />
        <path d="M-23,62 L23,62 L29,86 L-29,86 Z" />
        <path d="M42,62 L88,62 L94,86 L36,86 Z" />
      </g>
      <text
        x="228"
        y="104"
        fontFamily="Quattrocento, Georgia, serif"
        fontWeight="700"
        fontSize="76"
        fill="#241C2B"
      >
        Aldemis
      </text>
      <text
        x="228"
        y="148"
        fontFamily="Oswald, 'Arial Narrow', sans-serif"
        fontWeight="500"
        fontSize="31"
        letterSpacing="29.7"
        fill="#4A8A78"
      >
        FOUNDRY
      </text>
    </svg>
  );
}
